import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard__side" }
const _hoisted_2 = { class: "profile-creation-wizard__side-mobile" }
const _hoisted_3 = { slot: "bottom-sheet-content" }
const _hoisted_4 = { class: "profile-creation-wizard__side-desktop" }
const _hoisted_5 = { class: "profile-creation-wizard__side-description" }
const _hoisted_6 = { class: "profile-creation-wizard__side-iconTitle" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_bottom_sheet = _resolveComponent("joy-bottom-sheet")!
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_joy_bottom_sheet, {
        id: "expertise-details-bottom-sheet",
        "close-label": _ctx.$msg('general.close')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.details.expertise.help')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.details.expertise.paragraph.one')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.details.expertise.paragraph.two')), 1)
          ])
        ]),
        _: 1
      }, 8, ["close-label"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "profile-creation-wizard__side-container focus",
        style: _normalizeStyle(_ctx.tipsClassPosition)
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_joy_icon, {
              name: "briefcase",
              size: "small"
            }),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.details.expertise.help')), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.details.expertise.paragraph.one')), 1),
          _hoisted_7,
          _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.details.expertise.paragraph.two')), 1)
        ])
      ], 4)
    ])
  ]))
}